.BaseUINextContext1643403763__root{
  -st-states: madefor;
}

.BaseUINextContext1643403763__root.BaseUINextContext1643403763--madefor {
  --wbu-font-stack: var(--wix-font-stack);
  --wbu-font-weight-regular: var(--wix-font-weight-regular);
  --wbu-font-weight-medium: var(--wix-font-weight-medium);
  --wbu-font-weight-bold: var(--wix-font-weight-bold);
}

/* st-namespace-reference="../../../src/utils/BaseUINextContext.st.css" */